module.exports = __webpack_public_path__ + "static/media/sideBarToggle.dc4b7570.svg";